import * as client_hooks from '../../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [6,[2]],
		"/(app)/alerts": [7,[2]],
		"/(app)/bookmarks": [8,[2]],
		"/(app)/bugreport": [9,[2]],
		"/(app)/create-room": [10,[2]],
		"/(app)/create-space": [11,[2]],
		"/(app)/direct": [12,[2]],
		"/(app)/direct/[roomId]": [13,[2]],
		"/(app)/explore": [14,[2]],
		"/(app)/home": [15,[2,3]],
		"/(app)/home/[roomId]": [16,[2,3]],
		"/(app)/inbox": [17,[2]],
		"/(auth)/login": [31,[5]],
		"/(auth)/login/[homeserver]": [32,[5]],
		"/(app)/navigate": [18,[2]],
		"/privacy": [38],
		"/(app)/profile": [19,[2]],
		"/(auth)/register": [33,[5]],
		"/(auth)/register/[homeserver]": [34,[5]],
		"/(auth)/reset-password": [35,[5]],
		"/(app)/rooms": [20,[2]],
		"/(app)/rooms/[roomId]": [21,[2]],
		"/(app)/search": [22,[2]],
		"/(app)/settings": [23,[2,4]],
		"/(app)/settings/[section]": [24,[2,4]],
		"/(auth)/setup": [36,[5]],
		"/(auth)/setup/[step]": [37,[5]],
		"/(app)/space/[spaceId]": [25,[2]],
		"/(app)/space/[spaceId]/create-room": [27,[2]],
		"/(app)/space/[spaceId]/create-space": [28,[2]],
		"/(app)/space/[spaceId]/lobby": [29,[2]],
		"/(app)/space/[spaceId]/[roomId]": [26,[2]],
		"/(app)/to/[...permalink]": [30,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);